import { CommonModule } from "@angular/common";
import { Component, EventEmitter, HostListener, Output } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { MenuItem } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { PanelMenuModule } from "primeng/panelmenu";
import { AuthService } from "../../../shared/services/auth/auth.service";

@Component({
  selector: "app-admin-sidebar",
  standalone: true,
  imports: [CommonModule, RouterLink, PanelMenuModule, ButtonModule],
  templateUrl: "./admin-sidebar.component.html",
  styleUrl: "./admin-sidebar.component.scss",
})
export class AdminSidebarComponent {
  isLoggedIn = false;
  isCollapsed = false;
  isMobile = false;
  isDropdownOpen: { [key: string]: boolean } = {};
  menuItems = [
    {
      label: "Customers",
      icon: "pi pi-user",
      items: [
        {
          label: "List Customers",
          icon: "pi pi-users",
          routerLink: ["/admin/customers"],
        },
        {
          label: "Due Invoice",
          icon: "pi pi-exclamation-circle",
          routerLink: ["/admin/customers/invoiceable"],
        },
        {
          label: "Due Payment Processing",
          icon: "pi pi-exclamation-circle",
          routerLink: ["/admin/customers/payment-processing"],
        }
      ],
    },
    {
      label: "Billing",
      icon: "pi pi-money-bill",
      items: [
        {
          label: "Subscriptions",
          icon: "pi pi-history",
          routerLink: ["/admin/subscriptions"],
        },
        {
          label: "Invoices",
          icon: "pi pi-file",
          routerLink: ["/admin/invoices"],
        },
        {
          label: "Payments",
          icon: "pi pi-wallet",
          routerLink: ["/admin/payments"],
        },
      ],
    },
    {
      label: "Monitoring",
      icon: "pi pi-desktop",
      items: [
        {
          label: "Assets",
          icon: "pi pi-box",
          routerLink: ["/admin/assets"],
        },
      ],
    },
    {
      label: "Network",
      icon: "pi pi-sitemap",
      items: [
        {
          label: "Network Map",
          icon: "pi pi-share-alt",
          routerLink: ["/admin/network"],
        },
        {
          label: "Fiber List",
          routerLink: ["/admin/outside-plant/fiber/list"],
          icon: "pi pi-arrow-down-left-and-arrow-up-right-to-center",
        },
        {
          label: "Conduit List",
          routerLink: ["/admin/outside-plant/conduit/list"],
          icon: "pi pi-ticket",
        },
        {
          label: "Handhole List",
          routerLink: ["/admin/outside-plant/handhole/list"],
          icon: "pi pi-warehouse",
        },
      ],
    },
    {
      label: "Settings",
      icon: "pi pi-cog",
      items: [
        {
          label: "Platform Users",
          icon: "pi pi-users",
          routerLink: ["/admin/settings/users"],
        },
        {
          label: "Permissions",
          routerLink: ["/admin/settings/permissions"],
          icon: "pi pi-shield",
        }
      ],
    }
  ];

  collapsedMenuItems: MenuItem[] = [];
  @Output() collapse = new EventEmitter<boolean>();

  constructor(protected authService: AuthService, private router: Router) {
    this.authService.isLoggedIn$.subscribe((x) => {
      this.isLoggedIn = x;
    });
  }

  ngOnInit() {
    this.checkScreenSize();
    this.collapsedMenuItems = this.menuItems.map((item) => ({
      tooltip: item.label,
      icon: item.icon,
      items: item.items
        ? item.items.map((subItem) => ({
            tooltip: subItem.label,
            icon: subItem.icon || item.icon, // Inherit parent icon if subItem lacks one
            routerLink: subItem.routerLink,
          }))
        : [],
    }));
  }

  @HostListener("window:resize", [])
  checkScreenSize() {
    this.isMobile = window.innerWidth < 768;
  }

  logout() {
    this.authService
      .signOut()
      .then(() => {
        console.log("User logged out");
        this.router.navigate(["/login"]); // Redirect to login page
      })
      .catch((error) => {
        console.error("Error during logout:", error);
      });
  }

  toggleDropdown(menu: string): void {
    this.isDropdownOpen[menu] = !this.isDropdownOpen[menu];
  }

  toggleSidebar() {
    if (this.isMobile) {
      this.collapse.emit(false);
    } else {
      this.isCollapsed = !this.isCollapsed;
    }
  }

  onParentItemClick(item: any) {
    if (item.items && item.items.length > 0) {
      this.router.navigate([item.items[0].routerLink]); // Redirect to first sub-item
    }
  }
}
